module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/reports/noshow-90ab4c.png";